<template>
  <div class="cat_010municipio">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un municipio</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los municipios</option>        
        <option v-for="Municipio in Municipios" :value="Municipio.MunicipioId" :key="Municipio.MunicipioId">{{Municipio.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        Municipios: [],
        idDelModelo:null,        
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      hereda: Number     
     },     
     mounted(){      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido; 
      
       const params = {
          llave: this.idDelInput,
          valor: this.idDelModelo
       }
       this.$store.dispatch("A_PJ_Catalogo_Establecer010Municipio", params);
    },
    created() {      
       if(this.hereda != undefined){ //para que no truene se deja prop utilizada en otros sistemas, se agrega valor a parametros
          this.parametros.EntidadFederativaId = this.hereda;
       }

      this.cargaCatalogoDeMunicipios();
    },
    methods: {
      cargaCatalogoDeMunicipios: function() {       
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba
  
        axios.post(api.conexion + api.PJ.catalogos.C010Municipios, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {                           
              this.Municipios = respuesta.data.Municipios;                            
            }
          })
          .catch(excepcion => {
            console.error(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;

        const parametros =
        {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        let municipioOBJ = this.obtenerDomicilioObj({ idMunicipio: parseInt(evento.target.value) });
        this.$store.dispatch("A_PJ_Catalogo_Establecer010Municipio",parametros);
        this.$emit("valorParaElPadre",evento, municipioOBJ);                
      },
      obtenerDomicilioObj: function({ idMunicipio }) {
        return this.Municipios.find(m => m.MunicipioId == idMunicipio);
      }
    }   
  }
</script>

<style>
.cat_010municipio .form-control {
    background-color: white !important;
    color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/010Municipios.vue